<div class="block">
    <div class="container">
        <div class="not-found">
            <div class="not-found__404">
                Errore 404
            </div>

            <div class="not-found__content">
                <h1 class="not-found__title">Pagina non trovata</h1>

                <a class="btn btn-secondary btn-sm" href="index.html">Alla Home</a>
            </div>
        </div>
    </div>
</div>
